import { useCallback } from 'react'
import { useLocale } from './locale'
import { translationsCs, translationsPl, type Translations } from './translations'

type Vars = Record<string, string | number | null | undefined>

function applyVars(template: string, vars?: Vars): string {
  if (!vars) return template
  return template.replace(/\{\{\s*([a-zA-Z0-9_]+)\s*\}\}/g, (_m, key: string) => {
    const v = vars[key]
    return v === null || v === undefined ? '' : String(v)
  })
}

function getDict(locale: 'pl' | 'cs'): Translations {
  return locale === 'cs' ? translationsCs : translationsPl
}

export function useT() {
  const { locale } = useLocale()
  const dict = getDict(locale)

  const t = useCallback(
    (key: string, vars?: Vars) => {
      const pl = translationsPl[key]
      const value = dict[key] ?? pl ?? key
      return applyVars(value, vars)
    },
    [dict],
  )

  return { t }
}

